// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MobileNounActivityRow_wrapper__3-L7o","icon":"MobileNounActivityRow_icon__3n-VO","content":"MobileNounActivityRow_content__cEDSP"};